// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TableView: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
            stroke="currentColor"
        >
            <path
                fill="none"
                strokeWidth=".828"
                d="M6.333 17h5.334V1H6.333v16zM2 17h4.333V1H2a1 1 0 00-1 1v14a1 1 0 001 1zm9.667 0H16a1 1 0 001-1V2a1 1 0 00-1-1h-4.333v16z"
            />
        </svg>
    );
};

export default React.memo(TableView);
